import { render, staticRenderFns } from "./SettingsIndex.vue?vue&type=template&id=1d357956&"
import script from "./SettingsIndex.vue?vue&type=script&lang=js&"
export * from "./SettingsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d357956')) {
      api.createRecord('1d357956', component.options)
    } else {
      api.reload('1d357956', component.options)
    }
    module.hot.accept("./SettingsIndex.vue?vue&type=template&id=1d357956&", function () {
      api.rerender('1d357956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/SettingsIndex.vue"
export default component.exports